//
//
//
//
//
//
//
//
//

export default {
  props: {
    filePath: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
}
